<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      msg: ''
    }
  },
  beforeCreate() {
    const url = window.location.href
    let status


    const mainUrl = url.split('?')[0]
    if (!isNaN(parseInt(mainUrl.substring(mainUrl.length - 1, mainUrl.length)))) {
      window.location.href = mainUrl.substring(0, mainUrl.length - 2)

      status = mainUrl.substring(mainUrl.length - 1, mainUrl.length)
      this.msg = status == 1 ? 'Payment succeeded' : 'Payment failed'
      this.$store.commit('setMsg', this.msg)      
    }
    if (this.$route.path === '/home/pay') {
      this.$store.commit('setPay', true)
    }
  },
}
</script>

<style></style>
